import React from "react";
import { Routes, Route } from "react-router-dom";

// Components
import SecureRoutes from "./SecureRoutes";
import LoginPage from "../pages/login";

// Constants
import { MODULES } from "../constants/modules";
import ROUTES from "../constants/routes";
import { useTheme } from "../theme/themeCreate";
import { Button } from "antd";

function AppRoutes() {
    
  return (
    <div>

    <Routes>
      <Route path={ROUTES[MODULES.LOGIN.id]} element={<LoginPage />} />
      <Route path="*" element={<SecureRoutes />} />
    </Routes>
    </div>
  );
}

export default AppRoutes;
